<template>
  <div>
    <label v-if="label" class="form-label mb-1">
      {{ label }}
      <span v-if="required" class="text-danger">*</span>
    </label>
    <textarea
      :value="modelValue"
      class="form-control form-control-sm admin-json"
      :class="{ 'is-invalid': localError }"
      :rows="rows"
      :placeholder="placeholder"
      :disabled="disabled"
      @input="onInput"
    ></textarea>
    <div class="form-text" v-if="helpText">{{ helpText }}</div>
    <div class="invalid-feedback">{{ localError }}</div>
  </div>
</template>

<script setup>
import { computed, defineEmits, defineProps, watch } from 'vue'
import { parseJsonInput } from '@/admin/utils/adminApiUtils'

const props = defineProps({
  modelValue: {
    type: String,
    default: '',
  },
  label: {
    type: String,
    default: '',
  },
  required: {
    type: Boolean,
    default: false,
  },
  disabled: {
    type: Boolean,
    default: false,
  },
  rows: {
    type: Number,
    default: 8,
  },
  placeholder: {
    type: String,
    default: '',
  },
  helpText: {
    type: String,
    default: '',
  },
  allowAnyJson: {
    type: Boolean,
    default: false,
  },
})

const emit = defineEmits(['update:modelValue', 'validity-change'])

const parsedState = computed(() =>
  parseJsonInput(props.modelValue, {
    allowEmpty: !props.required,
    allowAnyJson: props.allowAnyJson,
  })
)
const localError = computed(() => parsedState.value.error)

const emitValidity = () => {
  emit('validity-change', {
    isValid: parsedState.value.isValid,
    error: parsedState.value.error,
  })
}

const onInput = event => {
  emit('update:modelValue', event?.target?.value || '')
}

watch(() => props.modelValue, emitValidity, { immediate: true })
</script>

<style scoped>
.admin-json {
  font-family: ui-monospace, SFMono-Regular, Menlo, Monaco, Consolas, 'Liberation Mono', 'Courier New', monospace;
}
</style>
